export default "__VITE_ASSET__CGtHhRIw__"